export default __webpack_public_path__ + "57c44bf06100ed3b53d9aa2b8c63de34.svg";